<template lang="html">

<section class="cover-popup row-center">
  <div class="popup column-center">
    <p>Por favor, acceda al menú Mi Perfil para completar sus datos.</p>
    <router-link :to="$t('enlaces.miperfil')" class="btn" :style="styles.solidPrimary" @click.native="hideRevisarPerfil">Aceptar</router-link>
  </div>
</section>

</template>

<script lang="js">

  import {mapGetters,mapActions} from 'vuex';

  export default  {
    name: 'popup-revisar-perfil',
    computed : {
      ...mapGetters({
        styles : 'getStyles'
      })
    },
    methods : {
      ...mapActions(['hideRevisarPerfil'])
    }
  }
</script>

<style scoped lang="scss">

@import '@/assets/css/colors.scss';


.btn{
  margin-top: 30px;
}

</style>



// WEBPACK FOOTER //
// src/components/parts/popup-revisar-perfil.vue